// headerApiSlice.js
import { apiSlice } from "./apiSlice";
import {
  HOMEPAGE_SLIDERS_URL,
  GET_MOBILE_SLIDERS_URL,
  HOMEPAGE_CATEGORIES_URL,
  HOMEPAGE_ADVERTS_URL,
} from "../constants";

export const homepageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHomepageSliders: builder.query({
      query: () => HOMEPAGE_SLIDERS_URL,
      method: "GET",
    }),
    getMobileSliders: builder.query({
      query: () => GET_MOBILE_SLIDERS_URL,
    }),
    getHomepageCategories: builder.query({
      query: () => HOMEPAGE_CATEGORIES_URL,
      method: "GET",
    }),
    getHomepageAdverts: builder.query({
      query: () => HOMEPAGE_ADVERTS_URL,
      method: "GET",
    }),
  }),
});

export const {
  useGetHomepageCategoriesQuery,
  useGetHomepageSlidersQuery,
  useGetMobileSlidersQuery,
  useGetHomepageAdvertsQuery,
} = homepageApi;
